import React from 'react';
import FormModal from '@shared/ui/FormModal';

interface StopTrackingConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  billNumber: string;
  workspaceName: string;
  isLoading?: boolean;
}

const StopTrackingConfirmDialog: React.FC<StopTrackingConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  billNumber,
  workspaceName,
  isLoading = false,
}) => (
  <FormModal
    isOpen={isOpen}
    title="Stop tracking this bill?"
    onClose={onClose}
    onSubmit={onConfirm}
    size="sm"
    submitLabel="Stop tracking"
    submitVariant="danger"
    cancelLabel="Keep tracking"
    isSubmitting={isLoading}
  >
    <p className="text-text-secondary dark:text-text-dark-secondary">
      Are you sure you want to stop tracking <strong>{billNumber}</strong> in the{' '}
      <strong>{workspaceName}</strong> workspace?
    </p>
    <p className="mt-2 text-sm text-text-tertiary dark:text-text-dark-tertiary">
      This removes the bill from your tracking list. Any notes on it are kept.
    </p>
  </FormModal>
);

export default StopTrackingConfirmDialog;
